$('[data-zoom]').on('click', function () {

    var t = $(this),
        subject = t.attr('data-zoom'),
        target = $('body')

    target.addClass('modalOpen').append('<div class="modal"><div class="modal__inner"><img src="' + subject + '" alt=""><div class="modal__close"></div></div><div class="modal__shroud"></div></div>')
})

$('body').on('click', '.modal__close, .modal__shroud', function () {
    closeModal()
})

$(document).keyup(function (e) {
    if (e.keyCode == 27 && $('body.modalOpen').length > 0) { // escape key maps to keycode `27`
        closeModal()
    }
})

function closeModal () {
    $('body').removeClass('modalOpen')
    $('.modal').addClass('modal__closing')
    setTimeout(function () {
        $('.modal').remove()
    }, 300)
}
